module.exports = __webpack_public_path__ + "img/上传文件.1fff678e.png";